import { motion, useReducedMotion } from "framer-motion";

const NODES = [
  { x: 90, y: 90, r: 7, label: "Governance" },
  { x: 300, y: 60, r: 9, label: "ISO 27001" },
  { x: 480, y: 120, r: 7, label: "Risk" },
  { x: 160, y: 230, r: 10, label: "Security" },
  { x: 380, y: 240, r: 8, label: "Compliance" },
  { x: 540, y: 300, r: 6, label: "Audit" },
  { x: 90, y: 380, r: 7, label: "Continuity" },
  { x: 280, y: 400, r: 9, label: "Resilience" },
  { x: 470, y: 420, r: 7, label: "Quality" },
];

const LINKS = [
  [0, 1], [1, 2], [0, 3], [1, 3], [1, 4], [2, 4], [2, 5],
  [3, 4], [4, 5], [3, 6], [3, 7], [4, 7], [4, 8], [5, 8],
  [6, 7], [7, 8],
];

export default function NetworkVisual() {
  const reduce = useReducedMotion();
  return (
    <div className="relative" data-testid="hero-network-visual">
      <svg viewBox="0 0 620 480" className="w-full h-auto" role="img" aria-label="Abstract network diagram connecting governance, security, compliance, continuity and resilience capabilities">
        <defs>
          <radialGradient id="nodeGlow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#2F80ED" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#2F80ED" stopOpacity="0" />
          </radialGradient>
        </defs>
        {LINKS.map(([a, b], i) => (
          <line
            key={i}
            x1={NODES[a].x} y1={NODES[a].y} x2={NODES[b].x} y2={NODES[b].y}
            stroke="rgba(47,128,237,0.28)" strokeWidth="1"
            strokeDasharray="4 8"
            className={reduce ? "" : "animate-dash-flow"}
            style={{ animationDelay: `${i * 0.12}s` }}
          />
        ))}
        {NODES.map((n, i) => (
          <g key={i}>
            <circle cx={n.x} cy={n.y} r={n.r * 3.2} fill="url(#nodeGlow)" opacity="0.35"
              className={reduce ? "" : "animate-pulse-node"} style={{ animationDelay: `${i * 0.4}s` }} />
            <circle cx={n.x} cy={n.y} r={n.r} fill="#081A33" stroke="#2F80ED" strokeWidth="1.5" />
            <circle cx={n.x} cy={n.y} r={n.r / 2.4} fill="#14B8A6" />
          </g>
        ))}
      </svg>
      {!reduce && (
        <>
          <motion.div
            className="absolute top-[8%] right-[4%] rounded-lg border border-white/15 bg-white/5 backdrop-blur-md px-4 py-2.5"
            animate={{ y: [0, -10, 0] }} transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
          >
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-teal">ISMS Status</p>
            <p className="text-sm font-semibold text-white">Controls Aligned</p>
          </motion.div>
          <motion.div
            className="absolute bottom-[12%] left-[2%] rounded-lg border border-white/15 bg-white/5 backdrop-blur-md px-4 py-2.5"
            animate={{ y: [0, 10, 0] }} transition={{ duration: 6, repeat: Infinity, ease: "easeInOut", delay: 1 }}
          >
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-teal">Continuity</p>
            <p className="text-sm font-semibold text-white">Plans Exercised</p>
          </motion.div>
          <motion.div
            className="absolute top-[46%] right-[10%] rounded-lg border border-white/15 bg-white/5 backdrop-blur-md px-4 py-2.5"
            animate={{ y: [0, -8, 0] }} transition={{ duration: 5.5, repeat: Infinity, ease: "easeInOut", delay: 0.5 }}
          >
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-teal">Risk Posture</p>
            <p className="text-sm font-semibold text-white">Continuously Reviewed</p>
          </motion.div>
        </>
      )}
    </div>
  );
}
